@for (item of selected; track item) {
<removable (remove)="remove(item)" class="selected">
  <ng-template
    component-host
    [spec]="config.toSelectedSpec(item)"
  ></ng-template>
</removable>
}

<div class="search-input">
  <input
    type="text"
    [matAutocomplete]="auto"
    [formControl]="searchControl"
    placeholder="{{ config.placeholder || 'Search' }}"
    class="form-control"
  />
  <icon type="search"></icon>
</div>

<mat-autocomplete #auto="matAutocomplete">
  @for (option of options | async; track option) {
  <mat-option [value]="option">
    <ng-template
      component-host
      [spec]="config.toOptionSpec(option, searchControl.value)"
    ></ng-template>
  </mat-option>
  }
</mat-autocomplete>
